'use client'

import { useState, useEffect } from 'react'
import CurrencyPrice from '@/components/CurrencyPrice'

export default function StatsTopMetrics({ bestSavingRoute }) {
  const [stats, setStats] = useState(null)

  useEffect(() => {
    fetch('/api/live-stats')
      .then(r => r.json())
      .then(setStats)
      .catch(() => {})
  }, [])

  const totalDeals     = stats?.totalDeals     ?? '—'
  const bestSavingEur  = stats?.bestSavingEur  ?? null
  const bestDiscount   = stats?.bestDiscount   ?? null
  const avgEuroSaving  = stats?.avgEuroSaving  ?? null
  const avgInterSaving = stats?.avgInterSaving ?? null

  const metrics = [
    { label: 'Live deals',               value: totalDeals,    suffix: '' },
    { label: 'Best saving today',         value: bestSavingEur  != null ? <CurrencyPrice amount={bestSavingEur} />  : '—', suffix: '', sub: bestSavingRoute },
    { label: 'Best discount today',       value: bestDiscount   != null ? bestDiscount   : '—', suffix: bestDiscount   != null ? '%' : '' },
    { label: 'Avg saved / trip (Europe)', value: avgEuroSaving  != null ? <CurrencyPrice amount={avgEuroSaving} />  : '—', suffix: avgEuroSaving  != null ? ' p.p.' : '' },
    { label: 'Avg saved / trip (long-haul)', value: avgInterSaving != null ? <CurrencyPrice amount={avgInterSaving} /> : '—', suffix: avgInterSaving != null ? ' p.p.' : '' },
  ]

  return (
    <>
      <section className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {metrics.map(({ label, value, suffix, sub }) => (
          <div key={label} className="bg-white rounded-2xl border border-gray-200 p-4 text-center">
            <p className="text-2xl font-bold text-gray-900">{value}{suffix}</p>
            <p className="text-xs text-gray-500 mt-1 leading-tight">{label}</p>
            {sub && <p className="text-xs text-blue-500 mt-0.5 leading-tight truncate">{sub}</p>}
          </div>
        ))}
      </section>
      <p className="text-xs text-gray-500 text-center -mt-3">
        Per person, round-trip. European deals save ~{avgEuroSaving != null ? <CurrencyPrice amount={avgEuroSaving * 4} /> : '?'} / year for a couple; long-haul ~{avgInterSaving != null ? <CurrencyPrice amount={avgInterSaving * 4} /> : '?'}.
      </p>
    </>
  )
}
